import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NgForm, FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from 'src/app/shared/components/modal-content/modal-content.component';
import { DWDPATSessionModel } from 'src/app/shared/models/session.model';
import { GetPayinTokensService } from 'src/app/shared/services/api/get-payin-tokens.service';
import { GetGuidService } from 'src/app/shared/services/api/get-guid.service';
import { DWDefaultPaymentRequest } from 'src/app/shared/models/DWDefaultPaymentRequest.model';
import { DWDeletePayRequest } from 'src/app/shared/models/DWDeletePayRequest.model';
import { DwPaymentProfiles, PayinTokens } from 'src/app/shared/models/payintokens.model';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeletePopupComponent } from '../delete-popup/delete-popup.component';
import { UserService } from 'src/app/shared/services/user.service';
import { DynamicPopupComponent } from 'src/app/shared/components/dynamic-popup/dynamic-popup';
import { SessionService } from 'src/app/shared/services/session.service';
import { AuthorizePaymentService } from 'src/app/shared/services/api/authorize-payment.service';
import { CreditCard, ListCreditCardsRequest, ListCreditCardsResponse, DeleteCreditCardPPIRequest, DeleteCreditCardPPIResponse,
        DeletePaymentMethodRequest, DeletePaymentMethodResponse,
      GetPaymentMethodsRequest, GetPaymentMethodsResponse } from 'src/app/shared/models/authorizeNet.model';
import { PpiPaymentMethodsService, SetDefaultPaymentRequest, SetDefaultPaymentResponse, } from 'src/app/shared/services/api/ppi-payment-methods.service';
import { HostedPaymentPopupComponent } from 'src/app/shared/components/hosted-payment-popup/hosted-payment-popup.component';
import { HostedPaymentEditPopupComponent } from 'src/app/shared/components/hosted-payment-edit-popup/hosted-payment-edit-popup.component';


@Component({
  selector: 'app-manage-payment',
  templateUrl: './manage-payment.component.html',
  styleUrls: ['./manage-payment.component.scss']
})
export class ManagePaymentComponent {
  paymenttokens: any;
  selectedtoken: any;
  cctokens: any;
  ectokens: any;
  dwdpatsession: DWDPATSessionModel = new DWDPATSessionModel;
  WalletID: any;
  paymentTokensAvailable: boolean = false;
  showSubMenu: boolean = true;
  frequency: any;
  isDefaultTokenAvailable:boolean=false;
  systemError: boolean = false;
  walletDetails:any;
  loading:boolean=true;
  disablebtn:boolean=false;
  InitialLoad:boolean=true;
  from: string = '';

  // NEW: Flag to store if the current user is from the PPI context
  isPPI: boolean = false;
  isBilliant: boolean = false;  // Flag to store if the current user is ONL/Billiant user

  sessionobj:any='';
  walletRole:string='';
  activeWallet: any;


  constructor(private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public getpayintoken: GetPayinTokensService,
    public sessionService: GetGuidService,
    private session_service: SessionService,
    private dialog: MatDialog,
    public userService:UserService,
    private coreSessionService: SessionService,
    private authorizePaymentService: AuthorizePaymentService,
    private ppiPaymentMethodsService: PpiPaymentMethodsService
) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showSubMenu = event.url.startsWith('/preferences');
      }
      if (sessionStorage.length > 0) {
        this.WalletID = JSON.parse(sessionStorage.getItem("WalletID") || '{}');
      }
    });
    this.walletRole = JSON.parse(sessionStorage.getItem("WalletRole"));
  }


    ngOnInit() {
    this.isPPI = this.coreSessionService.isPPI();
    this.route.queryParams.subscribe(params => {
      this.from = params['from'] || 'set-default';
    });

    const rawWalletID = sessionStorage.getItem("WalletID");
    const rawWalletRole = sessionStorage.getItem("WalletRole");
    const sessionID = sessionStorage.getItem("SessionID");

    const WalletID = rawWalletID ? JSON.parse(rawWalletID) : null;
    const WalletRole = rawWalletRole ? JSON.parse(rawWalletRole) : null;

     const initialSummaryPayload = {
        walletID: WalletID,
        walletRole: WalletRole,
        sessionID: sessionID
    };
    this.loading = true;

    if (sessionStorage.length > 0) {
      this.WalletID = JSON.parse(sessionStorage.getItem("WalletID") || '{}');
    }
    this.walletDetails = this.userService.getWalletDetails();
    this.loadpayintokens();

   this.session_service.isBilliant$.subscribe(val => {
      this.isBilliant = val;
      console.log("Header - Is Billiant:", this.isBilliant);
    });
  }

updateDefaultPayment(): void {
  this.disablebtn = true;

  if (this.isPPI) {
    // Call PPI default setter
    this.setPpiDefaultPayment();
  } else {
    // Call ONL default setter
    this.updateDefault();
  }
}

    
      updateDefault(){
    console.log(this.selectedtoken);
    if (this.selectedtoken != '') {
      let sessionID=sessionStorage.getItem("SessionID");
      let defaultTokenRequest: DWDefaultPaymentRequest = new DWDefaultPaymentRequest();
      defaultTokenRequest.token = this.selectedtoken;
      defaultTokenRequest.walletId = this.WalletID;
      defaultTokenRequest.sessionID=sessionID;

      this.getpayintoken.updatedefaulttoken(defaultTokenRequest).subscribe({
        next: (data: PayinTokens) => {
          console.log("default token is set is" + data.success);

               if (data.success) {
                // IMPORTANT: Tell the UserService to refresh its state
                this.userService.refreshWalletSummary().subscribe(() => {
                    // Navigate back only after the refresh is complete
                    if (this.from === 'pay-invoice') {
                        this.router.navigate(['/my-wallet/all-rewards/redeem/outstanding-invoice']);
                    } else if (this.from === 'auto-redeem') {
                        this.router.navigate(['/preferences/auto-redeem']);
                    } else {
                        this.loadpayintokens(); // Reload tokens on the same page
                    }
                });
            }


          let config=new MatDialogConfig();
      config.data="UpdateConfirmed";
      let dialogRef=this.dialog.open(DynamicPopupComponent,config);
      dialogRef.afterClosed().subscribe(
        result => {
          
          if (result=='accept') {
            
            if (result === 'accept') {
              // Decide final route based on “from”
              if (this.from === 'pay-invoice') {
                this.router.navigate(['/my-wallet/all-rewards/redeem/outstanding-invoice']);
                console.log("Accept and pay-invoice clicked");
              } else if (this.from === 'auto-redeem') {
                this.router.navigate(['/preferences/auto-redeem']);
                console.log("Accept and Turn on Auto Redeem clicked");
              } else {
                // from = set-default => stay on manage-payment
                console.log("Nothing clicked");
                this.loadpayintokens();
              }
            }
          }
          else{
            this.loadpayintokens();
          }
          
        }
      );
          
          
        }
      });

    }
  }

  //this.router.navigate(['/payment-tokens']);



  addPaymentMethod(): void {

    if (this.isPPI) {

 // 🚨 NEW LOGIC: Open the Hosted Payment Modal/Flyout here
   const dialogConfig = new MatDialogConfig();
   dialogConfig.width = '600px';
   dialogConfig.height = '600px';
   dialogConfig.disableClose = true; // Prevent closing by clicking outside during process
        
        const dialogRef = this.dialog.open(HostedPaymentPopupComponent, dialogConfig);
        
        dialogRef.afterClosed().subscribe(result => {
            if (result === 'success') {
                // If the dialog closed with 'success', refresh the card list
                this.loadpayintokens(); 
            } else {
                console.log('Payment modal closed without success result:', result);
            }
        });

   console.log('ManagePaymentComponent: Opening hosted-payment modal for PPI user.');

      // For PPI, navigate directly to hosted-payment page
     // this.router.navigate(['/hosted-payment']);
    //  console.log('ManagePaymentComponent: Navigating to hosted-payment for PPI user.');
    } else {

    if (sessionStorage.length > 0) {
      this.WalletID = JSON.parse(sessionStorage.getItem("WalletID") || '{}');
      this.sessionobj=JSON.parse(sessionStorage.getItem('ONLWalletSession') || '{}');
    }

    let sessionID=sessionStorage.getItem("SessionID");
    let isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
    this.dwdpatsession = new DWDPATSessionModel()
    this.dwdpatsession.action = 'addpayinpayment';
    this.dwdpatsession.callBackURL = `${ApiEndpoints.startWalletSessionCallBack}/preferences/manage-payment`;
    this.dwdpatsession.country = 'US';
    this.dwdpatsession.createdByUserId = 'appdw';
    this.dwdpatsession.locale = 'en';
    this.dwdpatsession.navigatingSystem = 'dw';
    this.dwdpatsession.paymentDirection = 'payin';
    this.dwdpatsession.walletID = this.WalletID;
    this.dwdpatsession.cashBalance=this.walletDetails?.cash?.totalCashBalance;
    this.dwdpatsession.rewardsBalance=this.walletDetails?.rewards?.totalRewardBalance;
    this.dwdpatsession.sessionID=sessionID;
    this.dwdpatsession.billingSystem=this.sessionobj.billingSystem;
    this.dwdpatsession.payorID=this.sessionobj.payorID;
    this.dwdpatsession.rewardsEligible=!isBilliant;
    this.sessionService.createdwdpatwalletsession(this.dwdpatsession);
  }
}

  enableBtn() {
this.InitialLoad=false;
  }

  submitForm(form: NgForm) {
    if (form.valid) {
      console.log(form.value);
    }
  }

  toggleSubMenu(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const isSubMenuLink = clickedElement.closest('li > ul a');

    if (isSubMenuLink) {
      // Keep the submenu open if a submenu link is clicked
      return;
    }

    this.showSubMenu = !this.showSubMenu;
    console.log('sub menu toggle');
  }


  updateNotification() {
    const modalRef = this.modalService.open(ModalContentComponent);
  }
  
  deleteToken(token: string) {

            // --- MANUAL OVERRIDE FOR TESTING ---
   
    // --- PPI DELETE REQUEST ---
if (this.isPPI) {
  console.log('ManagePaymentComponent: Deleting PPI card:', token);

  const methodToDelete = this.cctokens.find((card: CreditCard) => card.userCreditCardId === token);

  // Check if it's the default card
if (methodToDelete && methodToDelete.isDefault === true) {
  const config = new MatDialogConfig();
  config.data = 'CannotDeleteDefault';
  this.dialog.open(DynamicPopupComponent, config);
  return;
}

this.systemError = false;
const config = new MatDialogConfig();
config.autoFocus = false;
config.data = {
  isDefaultPaymentMethod: methodToDelete?.isDefault === true
};


  const dialogRef = this.dialog.open(DeletePopupComponent, config);
  dialogRef.afterClosed().subscribe(result => {
    if (result === 'confirm') {
      const deleteRequest: DeletePaymentMethodRequest = {
        userCreditCardID: token,
        userID: sessionStorage.getItem('PPIUserID') || '',
        customerID: sessionStorage.getItem('PPICustomerID') || '',
        sessionID: sessionStorage.getItem('SessionID') || '',
       walletID: JSON.parse(sessionStorage.getItem("WalletID") || '""')
      };

      this.authorizePaymentService.deletePaymentMethod(deleteRequest).subscribe({
        next: (response: DeletePaymentMethodResponse) => {
          if (response.success) {
            console.log('PPI card deleted successfully:', response);
            this.loadpayintokens(); // reload list
          } else {
            console.error('Failed to delete PPI card:', response.message);
            this.systemError = true;
          }
        },
        error: err => {
          console.error('Error calling PPI delete API:', err);
          this.systemError = true;
        }
      });
    }
  });
}


    else {


    const methodToDelete = this.paymenttokens.find(
      (m: any) => m.token === token
    );

    if (methodToDelete && methodToDelete.isDefaultPaymentMethod.toLowerCase() === 'true') {
      const config = new MatDialogConfig();
      config.data = 'CannotDeleteDefault';
      this.dialog.open(DynamicPopupComponent, config);
      return;
    }
    
    this.systemError = false;
    let isDefaultPaymentMethod; // Pop-up needs to know if we are deleting the default payment method or not
    let tokenMatched = false; // We will not open pop-up unless it matches a token from paymenttokens list (it should, this is for extreme error handling)
    for (let i=0; i<this.paymenttokens?.length; i++) {
      if (this.paymenttokens[i].token == token) {
        isDefaultPaymentMethod = this.paymenttokens[i].isDefaultPaymentMethod?.toLowerCase() == 'true';
        tokenMatched = true;
      }
    }

    if (tokenMatched) {
      let config = new MatDialogConfig();
      config.autoFocus = false;
      config.data = {
        isDefaultPaymentMethod: isDefaultPaymentMethod
      };

      let dialogRef = this.dialog.open(DeletePopupComponent, config);

      dialogRef.afterClosed().subscribe(
        result => {
          if (result == 'confirm') {
            let dwDeletePayRequest: DWDeletePayRequest = new DWDeletePayRequest();
            dwDeletePayRequest.Token = token;
            dwDeletePayRequest.sessionID=sessionStorage.getItem("SessionID");
            this.getpayintoken.deletepaymentmethod(dwDeletePayRequest).subscribe({
              next: (data: PayinTokens) => {
                if (data?.success) {
                  this.loadpayintokens();
                } else {
                  this.systemError = true;
                  
                }
              }, error: (err) => {
                this.systemError = true;
                
              }
            });
          }
        }
      );
    } else {
      this.systemError = true;
      
    }
  }
  }

      editPaymentMethod(card: CreditCard): void {
    console.log('ManagePaymentComponent: Editing card:', card.userCreditCardId);
    // Navigate to hosted-payment-edit page, passing userCreditCardId as a route parameter
    //this.router.navigate(['/hosted-payment-edit', card.userCreditCardId]);
       if (this.isPPI) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true; // Prevent closing by clicking outside or pressing ESC
      dialogConfig.width = '600px';
            // Pass the required card ID to the modal
      dialogConfig.data = { userCreditCardID: card.userCreditCardId }; 

      const dialogRef = this.dialog.open(HostedPaymentEditPopupComponent, dialogConfig);
      
      // Subscribe to the result of the modal when it closes
      dialogRef.afterClosed().subscribe(result => {
        // 'success' is returned if the Notify API was successfully called inside the modal
        if (result === 'success') {
          console.log('Payment Edit modal closed successfully. Refreshing token list.');
          this.loadpayintokens(); // Refresh the list to show the updated card details
        } else if (result === 'cancel') {
          console.log('Payment Edit modal closed/cancelled.');
        }
      });
    }
  }

  loadpayintokens() {

     this.loading = true; // Start loading
    this.paymentTokensAvailable = false; // Reset availability

if (this.isPPI) {
  const walletId = JSON.parse(sessionStorage.getItem("WalletID") || 'null'); 
const sessionId = sessionStorage.getItem("SessionID") || '';
const userID = sessionStorage.getItem("PPIUserID") || '';
const customerID = sessionStorage.getItem("PPICustomerID") || '';

console.log("DEBUG - walletId:", walletId, "userID:", userID, "customerID:", customerID, "sessionID:", sessionId);

const request: GetPaymentMethodsRequest = {
  walletID: walletId,
  userID,
  customerID,
  sessionID: sessionId
};


  this.authorizePaymentService.getPaymentMethods(request).subscribe({
    next: (response: GetPaymentMethodsResponse) => {
      if (response.ppi?.success && response.ppi.paymentMethods?.length > 0) {
        this.paymentTokensAvailable = true;
        this.cctokens = response.ppi.paymentMethods;

        // Add cardImg (optional: reuse your getcardImage utility)
        this.cctokens.forEach((card: CreditCard) => {
          card.cardImg = this.getpayintoken.getcardImage(card.creditCardType, '');
          card.isDefault = String(card.isDefault).toLowerCase() === 'true';  
        });

        // Detect default card
        const defaultCard = this.cctokens.find(c => c.isDefault === true);
        if (defaultCard) {
          this.selectedtoken = defaultCard.userCreditCardId;
          this.isDefaultTokenAvailable = true;
        } else {
          this.isDefaultTokenAvailable = false;
        }

      } else {
        this.paymentTokensAvailable = false;
        this.cctokens = [];
        this.isDefaultTokenAvailable = false;
        console.log('No PPI payment methods found:', response.ppi?.message);
      }

      this.loading = false;
      this.disablebtn = false;
      this.InitialLoad = false;
    },
    error: (error) => {
      console.error('Error fetching PPI payment tokens (dwGetPaymentMethod):', error);
      this.systemError = true;
      this.loading = false;
      this.disablebtn = false;
      this.InitialLoad = false;
    }
  });
}
else {


    let listoftokens = this.getpayintoken.fetchpayintokens(this.WalletID).subscribe({
      next: (data: PayinTokens) => {
                if (data.paymentMethods != undefined) {
          this.paymentTokensAvailable = true;
                  }
        else{
          this.loading=false;
          return
        }
        this.paymenttokens = data.paymentMethods;
        this.paymenttokens.forEach((token: any) => {
          token.cardImg = this.getpayintoken.getcardImage(token.cardType,token.ccholderName);
          
        });

        this.cctokens = this.paymenttokens.filter((x: any) => x.paymentMethod == 'CC');
        this.ectokens = this.paymenttokens.filter((x: any) => x.paymentMethod == 'ECP');
        let isDefaultPaymentMethod=this.paymenttokens.filter((x: any) => x.isDefaultPaymentMethod.toLowerCase() == 'true');
        if(isDefaultPaymentMethod.length>0){
          this.isDefaultTokenAvailable=true;

        }
        
        this.loading=false;
        this.disablebtn=false;
      }
    });
  }
  }

  setPpiDefaultPayment(): void {
  if (!this.selectedtoken) {
    console.error("No token selected for default payment");
    return;
  }

  const request: SetDefaultPaymentRequest = {
    userCreditCardID: this.selectedtoken,
    userID: sessionStorage.getItem('PPIUserID') || '',
    customerID: sessionStorage.getItem('PPICustomerID') || '',
    sessionID: sessionStorage.getItem('SessionID') || '',
    walletID: JSON.parse(sessionStorage.getItem('WalletID') || '""')
  };

  this.disablebtn = true;

  this.ppiPaymentMethodsService.setDefaultPaymentMethod(request).subscribe({
    next: (response) => {
      console.log('Set default payment response:', response);
      this.disablebtn = false;

      if (response?.statusCode === "200" || response?.message?.toLowerCase().includes("success")) {
        // refresh tokens
        this.loadpayintokens();
        // maybe show popup like delete flow
        const config = new MatDialogConfig();
        config.data = "UpdateConfirmed";
        this.dialog.open(DynamicPopupComponent, config);
      } else {
        this.systemError = true;
      }
    },
    error: (err) => {
      console.error("Error setting PPI default payment method:", err);
      this.systemError = true;
      this.disablebtn = false;
    }
  });
}


  formatExpirationDate(expiration: string): string {
    if (!expiration || expiration.length !== 6)
      if(expiration.length==4)
        { const month = expiration.substring(0, 2); // Extract the year
          const year = expiration.substring(2, 4);
          
          return `${month}/${year}` }// Handle invalid input
  
    const year = expiration.substring(0, 4); // Extract the year
    const month = expiration.substring(4, 6); // Extract the month
  
    return `${month}/${year.substring(2, 4)}`; // Format as MM/YY
  }

  isExpired(expiration: string): boolean {
  if (!expiration) return false;

  // Assuming format is MMYY or MMYYYY (e.g., "1225" or "122025")
  const month = parseInt(expiration.substring(0, 2), 10);
  let year = parseInt(expiration.substring(2), 10);

  // Adjust 2-digit year to 4-digit (e.g., 25 to 2025)
  if (expiration.length === 4) {
    year += 2000;
  }

  const now = new Date();
  const currentMonth = now.getMonth() + 1; // getMonth() is 0-indexed
  const currentYear = now.getFullYear();

  if (year < currentYear) {
    return true;
  } else if (year === currentYear && month < currentMonth) {
    return true;
  }

  return false;
}
  

}
